import { useDispatch, useSelector } from 'react-redux'
import { CHECKBOX_TRADE_DISCOUNT } from '../../../../cartAndOrders/constant'
import {
  selectCheckDisCountAndVoucher,
  selectDiscountOrder,
  selectVoucher,
} from '../../../../cartAndOrders/store/slice'
import useGetVAT from '../../../../common/category/useVAT'
import { Element } from '../../../../common/html/element'
import classes from '../../../index.module.scss'
import { selectBuyPackage, setBuyOnePackage } from '../../store/slice'
import { formatPrice } from '../helper'
import '../lang/i18n'
import { AddNewPackage } from './common/AddNewPackage'
import { ChoosePackageList } from './common/ChoosePackageList'
import { PackageItem } from './common/PackageItem'
import { Price } from './common/price'

export const BuyOnePackage = ({ defaultReportId }) => {
  const dispatch = useDispatch()

  const buyPackage = useSelector(selectBuyPackage)

  const checkDiscountAndVoucher = useSelector(selectCheckDisCountAndVoucher)
  const dataVoucher = useSelector(selectVoucher)
  const discountOrder = useSelector(selectDiscountOrder)

  const { vatPercentage } = useGetVAT()

  const listPackage = buyPackage?.listPackage

  const totalAllPackagePrice = listPackage
    ?.map((item) => item.totalPrice || 0)
    .reduce((sum, acc) => sum + acc, 0)
  const totalDiscountProduct = listPackage
    ?.map((item) => item.totalPrice * item.discountPercentage || 0)
    .reduce((sum, acc) => sum + acc, 0)
  //
  const priceDiscountRaw =
    (totalAllPackagePrice - totalDiscountProduct) *
      discountOrder?.discountPercentage || 0

  const priceVoucher = checkDiscountAndVoucher[CHECKBOX_TRADE_DISCOUNT.VOUCHER]
    ? (totalAllPackagePrice - totalDiscountProduct) *
      dataVoucher?.discountPercentage
    : 0
  const discountedPrice = formatPrice(priceDiscountRaw + priceVoucher)

  const priceNotIncludedVAT =
    totalAllPackagePrice - discountedPrice - totalDiscountProduct
  const vatPrice = vatPercentage * priceNotIncludedVAT
  const grandTotalPrice = priceNotIncludedVAT + vatPrice

  const onAddBtnClick = () => {
    dispatch(setBuyOnePackage(false))
  }

  return (
    <>
      <div className={[classes.content, 'flexColumn'].join(' ')}>
        <ChoosePackageList />
        <PackageItem
          isBuyOnePackage
          defaultReportId={defaultReportId}
          classNamePrice={classes.w150}
        />
        <Price
          title="userManagement.packageSubManagement.TRADE_DISCOUNT"
          price={totalDiscountProduct ?? 0}
          classNamePrice={classes.w150}
        />
        <Price
          title="userManagement.buyPackage.TRADE_DISCOUNT"
          price={discountedPrice ?? 0}
          classNamePrice={classes.w150}
          isDiscount
        />
        <Price
          title="userManagement.buyPackage.VAT"
          price={vatPrice ?? 0}
          classNamePrice={classes.w150}
        />
        <Price
          title="userManagement.buyPackage.GRAND_TOTAL"
          price={grandTotalPrice ?? 0}
          classNamePrice={classes.w150}
        />
        <Element className={classes.dashedLine} />
      </div>
      <div className="flexColumn">
        <Element className="flexRow" onClick={onAddBtnClick}>
          <AddNewPackage />
        </Element>
      </div>
    </>
  )
}
